import { RiTodoLine } from 'react-icons/ri'
import { MenuItem } from '../types'
import { BiMemoryCard } from 'react-icons/bi'
import { FaRegLightbulb } from 'react-icons/fa'
import { AiOutlineLink } from 'react-icons/ai'
import {
  MdOutlineLocalMovies,
  MdOutlineLocationOn,
  MdOutlineReportProblem,
} from 'react-icons/md'
import { PiBowlFood } from 'react-icons/pi'
import { LiaRingSolid } from 'react-icons/lia'
import { IoAirplaneOutline } from 'react-icons/io5'

const notesMenu: MenuItem[] = [
  {
    icon: RiTodoLine,
    name: 'To-Dos',
    path: '/notes/to-dos',
    code: 'to-dos',
  },
  {
    icon: BiMemoryCard,
    name: 'Memories',
    path: '/notes/memories',
    code: 'memories',
  },
  {
    icon: FaRegLightbulb,
    name: 'Ideas',
    path: '/notes/ideas',
    code: 'ideas',
  },
  {
    icon: MdOutlineLocalMovies,
    name: 'Movies',
    path: '/notes/movies',
    code: 'movies',
  },
  {
    icon: AiOutlineLink,
    name: 'Links',
    path: '/notes/links',
    code: 'links',
  },
  {
    icon: MdOutlineLocationOn,
    name: 'Locations',
    path: '/notes/locations',
    code: 'locations',
  },
  {
    icon: PiBowlFood,
    name: 'Recipes',
    path: '/notes/recipes',
    code: 'recipes',
  },
  {
    icon: IoAirplaneOutline,
    name: 'Trips',
    path: '/notes/trips',
    code: 'trips',
  },
  {
    icon: LiaRingSolid,
    name: 'Wedding',
    path: '/notes/wedding',
    code: 'wedding',
  },
  {
    icon: MdOutlineReportProblem,
    name: 'Protocols',
    path: '/notes/protocols',
    code: 'protocols',
  },
]

export default notesMenu
